import {
    SOCIETY_PORTAL,
    SOCIETY_PORTAL_MEMBERS_ADD_OWNER,
    SOCIETY_PORTAL_MEMBERS_ADD_TENANT,
    SOCIETY_PORTAL_MEMBERS_ADD_FAMILY,
    SOCIETY_PORTAL_MEMBERS_OWNERS,
    SOCIETY_PORTAL_MEMBERS_TENANTS,
    SOCIETY_PORTAL_MEMBERS_FAMILY,
} from '../../../../Routing/routes';

const memberRoleConfig = {
    owner: {
        role: 'owner',
        pageTitle: 'Owners',
        pageSubtitle: 'Manage society owners',
        addButtonLabel: 'Add Owner',
        addRoute: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_ADD_OWNER,
        backRoute: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_OWNERS,
        editModalKey: 'owner',
        statsCards: [
            { icon: 'mdi:account-key', color: 'tw-bg-emerald-500', valueKey: 'total', label: 'Total Owners' },
        ],
    },
    tenant: {
        role: 'tenant',
        pageTitle: 'Tenants',
        pageSubtitle: 'Manage society tenants',
        addButtonLabel: 'Add Tenant',
        addRoute: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_ADD_TENANT,
        backRoute: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_TENANTS,
        editModalKey: 'tenant',
        // Active / Inactive status, end dates and per-flat tenant history.
        tenancyHistory: true,
        statsCards: [
            { icon: 'mdi:account-clock', color: 'tw-bg-purple-500', valueKey: 'allTenants', label: 'Total Tenants' },
            { icon: 'mdi:account-check', color: 'tw-bg-emerald-500', valueKey: 'active', label: 'Active' },
            { icon: 'mdi:account-off-outline', color: 'tw-bg-gray-500', valueKey: 'inactive', label: 'Inactive (Past)' },
        ],
    },
    family: {
        role: 'family',
        pageTitle: 'Family Members',
        pageSubtitle: 'Manage family members',
        addButtonLabel: 'Add Family Member',
        addRoute: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_ADD_FAMILY,
        backRoute: SOCIETY_PORTAL + SOCIETY_PORTAL_MEMBERS_FAMILY,
        editModalKey: 'family',
        statsCards: [
            { icon: 'mdi:account-group', color: 'tw-bg-blue-500', valueKey: 'total', label: 'Total Family Members' },
        ],
    },
};

export default memberRoleConfig;
